const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://tnjvdswykmzvxcwfoycj.supabase.co';
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  '';

interface NavigatorWithConnection extends Navigator {
  connection?: { effectiveType?: string };
}

const navigationStartTimes = new Map<string, number>();

export const initPageViewTimer = () => {
  const page = window.location.pathname;
  navigationStartTimes.set(page, performance.now());
};

export const reportPageView = (page: string) => {
  try {
    const nav = navigator as NavigatorWithConnection;
    const navStart = navigationStartTimes.get(page);
    const loadTime = navStart ? Math.round(performance.now() - navStart) : null;
    navigationStartTimes.delete(page);

    const payload = {
      page,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      connection_type: nav.connection?.effectiveType || null,
      screen_width: window.screen.width,
      screen_height: window.screen.height,
      load_time_ms: loadTime,
    };

    const url = `${SUPABASE_URL}/functions/v1/log-page-view`;
    const body = JSON.stringify(payload);

    const requestInit: RequestInit = {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY ? { apikey: SUPABASE_ANON_KEY } : {}),
      },
      body,
    };

    fetch(url, requestInit).catch(() => {
      // One delayed retry improves reliability in unstable mobile networks/WebViews
      setTimeout(() => {
        fetch(url, requestInit).catch(() => {});
      }, 800);
    });
  } catch {
    // never throw from page view reporter
  }
};
